import { findErrorsInModel } from '../utils/validation/findErrorsInModel';
import { validationMessages } from '../constants/validation/employmentDetails';
import { isValidInput } from '../utils/validation/isValidInput';
import { UNEMPLOYED_STATUS, SELF_EMPLOYED_STATUS } from '../constants/general';
import { isEconomicallyInactive, isIndustryRequired } from '../utils/employment';
import { isValidHouseholdIncome } from '../utils/validation/isValidHouseholdIncome';

function getSchema(model, personalDetails) {
  const isRequired = model && !isEconomicallyInactive(model.employmentStatus);
  const industryRequired = model && isIndustryRequired(model.employmentStatus);
  const jobLevelRequired =
    model &&
    isIndustryRequired(model.employmentStatus) &&
    model.employmentStatus !== SELF_EMPLOYED_STATUS;
  let isEmployerOwnName = false;

  if (model && personalDetails && isRequired) {
    const { title, firstName, middleName, lastName } = personalDetails;
    const customerName = title
      .concat(firstName || '', middleName || '', lastName || '')
      .replace(/\s/g, '');
    const empName = model.employerName.replace(/\s/g, '');

    if (empName && customerName && empName.toLowerCase() === customerName.toLowerCase()) {
      isEmployerOwnName = true;
    }
  }

  return {
    employmentStatus: (value) =>
      (value === '' || (value && value.trim() === '') || value === UNEMPLOYED_STATUS) &&
      (value === UNEMPLOYED_STATUS
        ? validationMessages.unemployedStatus
        : validationMessages.employmentStatus),
    employerName: (value) => {
      return (
        (isRequired && value === '' && validationMessages.employerName) ||
        (isRequired && !isValidInput(value, 'Alphabet') && validationMessages.employerName) ||
        (isRequired && value !== '' && value.length > 40 && validationMessages.employerName) ||
        (isEmployerOwnName && value !== '' && validationMessages.employerOwnName)
      );
    },
    employmentJobLevel: (value) => {
      return jobLevelRequired && value === '' && validationMessages.employmentJobLevel;
    },
    employmentIndustry: (value) => {
      return industryRequired && value === '' && validationMessages.employmentIndustry;
    },
    earnIncome: (value) => {
      if (
        model.financialCircumstances == 'Yes' &&
        (value.length > 7 || !isValidInput(value, 'Numeric'))
      ) {
        return validationMessages.earnIncome;
      }
    },
    mortgageExpense: (value) => {
      if (value === '' || value.length > 6 || !isValidInput(value, 'Numeric')) {
        return validationMessages.mortgageExpense;
      }
    },
    grossAnnualIncome: (value) => {
      if (
        value === '' ||
        value.length > 7 ||
        !isValidInput(value, 'Numeric') ||
        Number(value) === 0
      ) {
        return validationMessages.grossAnnualIncome;
      }
    },
    netMonthlyIncome: (value) => {
      // this value is still named netMonthlyIncome but the actual value it represents is the total household income

      if (
        (model && !isValidHouseholdIncome(value, model.grossAnnualIncome)) ||
        !isValidInput(value, 'Numeric') ||
        Number(value) === 0 ||
        (value !== '' && value.length > 7)
      ) {
        return validationMessages.netMonthlyIncome;
      }
    },
    financialCircumstances: (value) => value === '' && validationMessages.financialCircumstances
  };
}

export const validateModel = (model, personalDetails) => {
  const schema = getSchema(model, personalDetails);
  const foundErrors = findErrorsInModel(model, schema);
  return foundErrors;
};

export const validateFormField = (field, value) => {
  const schema = getSchema();
  return schema[field] && schema[field](value);
};
